<template>
    <v-layout>
        <v-flex>
            <v-card>
                <v-card-title>
                    <h3 class="headline mb-0 admin-header">Configurations</h3>
                    <v-btn text icon color="grey lighten-1" @click="refresh(pagination)"><v-icon>fas fa-sync</v-icon></v-btn>
                </v-card-title>
                <v-card-text>
                    <v-layout wrap>
                        <span class="subheading"><b>Filters:</b></span>
                        <v-icon v-if="showFilters" @click="showFilters = !showFilters">fal fa-chevron-up</v-icon>
                        <v-icon v-if="!showFilters" @click="showFilters = !showFilters">fal fa-chevron-down</v-icon>
                    </v-layout>
                        <v-form v-model="valid" v-if="showFilters" @submit.prevent>
                    <v-layout wrap>
                        <v-flex xs11>
                            <v-layout wrap>
                                <v-flex xs2 ml-4>
                                    <v-autocomplete
                                    v-model="orgId"
                                    :items="organizations"
                                    label="Organization"
                                        item-text="text"
                                        item-value="value">
                                    </v-autocomplete>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-text-field label="Key" v-model="key"></v-text-field>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-text-field label="Value" v-model="value"></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs1>
                            <button onsubmit="false" class="btn btn-primary" @click="applyFilters" :disabled="!valid">Apply</button>
                            <button onsubmit="false" class="btn btn-default" @click="resetFilters">Reset</button>
                        </v-flex>
                    </v-layout>
                        </v-form>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-data-table
                              :items="appConfigs.content"
                              :loading="loading"
                              :headers="headers"
                              :options.sync="pagination"
                              :footer-props="{'items-per-page-options': [5, 10, 15, 20, 50, 100]}"
                              :server-items-length="totalItems" class="elevation-1"
                            >
                              <template v-slot:item.parameter.name="{item}">
                                <td>
                                  <router-link v-if="isSUPro" to="" @click.native="editItem(item)">{{item.parameter.name}}</router-link>
                                  <span v-else>{{item.parameter.name}}</span>
                                </td>
                              </template>
                              <template v-slot:item.actions="{item}">
                                <td class="actions" v-if="isSUPro">
                                  <v-btn text icon @click="editItem(item)"
                                    style="height: 0px; width: 0px; padding-right:2px;"
                                  >
                                    <v-icon color="grey lighten-1" style="font-size: 18px;" >fas fa-pencil</v-icon>
                                  </v-btn>
                                </td>
                              </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
            <v-dialog v-model="showEditConfigDialog" max-width="600px">
                <v-card>
                    <v-card-title>
                    <span class="headline">Config</span>
                    </v-card-title>

                    <v-card-text>
                        <v-form v-model="validConfig" @submit.prevent>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12 class="subheading">
                                   Id: {{editedItem.id}} OrgId: {{editedItem.orgId}}
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-text-field v-model="editedItem.parameter.key" label="Key" :readonly="true"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-text-field v-model="editedItem.parameter.name" label="Name" :readonly="true"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-text-field v-model="editedItem.parameter.description" label="Description" :readonly="true"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-text-field v-model="editedItem.value" label="Value"></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn class="mr-4" color="primary" outlined rounded  @click.native="close">Cancel</v-btn>
                        <v-btn color="primary" rounded  :disabled="!validConfig" @click.native="save">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-flex>
    </v-layout>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import moment from 'moment'
import Utility from './utility'
export default {
    computed: {
        ...mapGetters('user', {
            organizations: 'getOrganizationsTextValue',
            isSUPro: 'isSUPro'
        }),
        ...mapGetters('menus', {
          findRouteTitle: 'findRouteTitle'
        }),
        routeTitle: {
          get() {
            return this.findRouteTitle(this.$route.name) || this.title
          }
        }
    },
    data() {
        return {
            appConfigs: {
                "content": [],
                "totalElements": 0
            },
            loading: false,
            search: '',
            pagination : {
                    descending: false,
                    page: 1,
                    rowsPerPage: 10, // -1 for All",
                    itemsPerPage: 10,
                    sortBy: ["id"]
            },
            totalItems: 0,
            headers: [
                {text: 'Id', align: 'left', sortable: true, value: 'id'},
                {text: 'Org Id', align: 'left', sortable: true, value: 'orgId'},
                // {text: 'Org Name', align: 'left', sortable: false, value: 'org.name'},
                {text: 'Key', align: 'left', sortable: true, value: 'parameter.key'},
                {text: 'Name', align: 'left', sortable: true, value: 'parameter.name'},
                {text: 'Description', align: 'left', sortable: true, value: 'parameter.description'},
                {text: 'Value', align: 'left', sortable: false, value: 'value'}
            ],
            orgId: null,
            key: null,
            value: null,
            valid: false,
            showFilters: true,
            validConfig: false,
            showEditConfigDialog: false,
            editedItem: {
                id: -1,
                parameter: {key: '', name: '', description: ''},
                value: '',
                orgId: '',
                org: {id: '', name: ''}
            },
            defaultItem: {
                id: -1,
                parameter: {key: '', name: '', description: ''},
                value: '',
                orgId: '',
                org: {id: '', name: ''}
            }
        }
    },
    watch: {
        pagination: {
            async handler () {
                await this.refresh(this.pagination)
            }, deep: true
        }
    },
    created() {
        if (this.isSUPro) {
            this.headers.push({text: 'Actions', align: 'left', sortable: false, value: 'actions'})
        }
    },
    methods: {
        async refresh(pagination) {

            const { page, itemsPerPage, sortBy, sortDesc } = pagination

            let sort = ""
            if (sortBy && sortBy.length) {
                sort = sortBy[0] + "," + (sortDesc && sortDesc.length && sortDesc[0] ? 'desc' : 'asc')
            }

            let filter = Utility.buildQueryString(['key', 'value', 'org_id'],
                              [this.key, this.value, this.orgId], ['key', 'value'])

            this.loading = true

            this.appConfigs = await this.$store.dispatch('crossorg/getAppConfigs',
                {filter, size: itemsPerPage || 10, page: page ? page - 1 : 0, sort})

            this.totalItems = this.appConfigs.totalElements

            this.loading = false
        },
        formatDateTime(val) {
            return moment(val).isValid() ? moment(val).format('MM/DD/YYYY, h:mm:ss a') : val
        },
        async resetFilters() {
            this.key = null
            this.orgId = null
            this.value = null

            await this.refresh(this.pagination)

        },
        async applyFilters() {
            await this.refresh(this.pagination)
        },
        async editItem (item) {
            this.editedItem = Object.assign({}, item)
            this.showEditConfigDialog = true
        },
        close() {
            this.showEditConfigDialog = false
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
            }, 300)
        },
        async save () {
            await this.$store.dispatch("crossorg/updateConfig", {config: this.editedItem})
            this.close()

            await this.refresh(this.pagination)
        }
    }
}
</script>
